import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Make sure to import the carousel styles
import Style from "../../assets/css/main.module.css";
import clockIcon from "../../assets/icons/clock.svg";
import locationIcon from "../../assets/icons/location.svg";
import rideIcon from "../../assets/icons/ride.svg";
import logo from "../../assets/images/logo.svg";
import { convertToAmPm } from "../../library/helpers";
import { selectBranch, setBranches } from "../../store/features/branchSlice";
import Sliders from "../slider/Sliders";

export default function Banner({ park }) {
  const dispatch = useDispatch();
  const { branches, selectedBranch } = useSelector(
    (state) => state.branchSlice
  );
  const [branch, setBranch] = useState(null);

  useEffect(() => {
    const finding = branches?.find(
      (item) => item.id === Number(selectedBranch)
    );
    setBranch(finding);
  }, [branches, selectedBranch]);

  useEffect(() => {
    dispatch(setBranches(park.branches));
  }, [dispatch, park]);

  return (
    <div
      className={`${Style.bg_primary_200} d-flex flex-column gap-2 p-2 h-100`}
    >
      <div className="park-slider-container">
        <Sliders items={park?.photos || []} />
      </div>
      <Row
        className="justify-content-center position-relative"
        style={{ top: "-50px" }}
      >
        <Col md={7}>
          <div className="d-flex flex-column gap-2 px-3 py-2">
            <div>
              <img
                src={park.logo || logo}
                alt="logo"
                style={{ width: "100px", height: "66px" }}
              />
            </div>
            <Row>
              {park?.rides?.map((item) => (
                <Col md={6} className="mb-1" key={item.id}>
                  <div
                    className={`${Style.fw_350} ${Style.fs_16} ${Style.text_primary} d-flex align-items-start gap-1`}
                  >
                    <div>
                      <img src={rideIcon} alt="ride" />
                    </div>
                    <div>{item.name}</div>
                  </div>
                </Col>
              ))}
              {park?.rides?.length < park.ride_count && (
                <Col md={6} className="mb-1">
                  <div
                    className={`${Style.fw_350} ${Style.fs_16} ${Style.text_primary} d-flex align-items-center gap-1`}
                  >
                    <div>and {park.ride_count - park.rides.length} more</div>
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </Col>
        <Col md={5}>
          <div className="d-flex flex-column gap-2 py-2">
            <div className={`${Style.fs_12} ${Style.fw_350} `}>
              Search your location to locate the nearby branches
            </div>
            <div
              className={`${Style.bg_light_100} d-flex w-100 align-items-center`}
            >
              <div className={`${Style.park} w-100`}>
                <select
                  name=""
                  className="w-100"
                  onChange={(e) => dispatch(selectBranch(e.target.value))}
                  style={{ height: "40px !important" }}
                >
                  {park?.branches?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name.length > 20
                        ? `${item.name.slice(0, 20)}...`
                        : item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="pe-2">
                <img src={locationIcon} alt="location" />
              </div>
            </div>
            <div className="d-flex flex-column align-items-start gap-2">
              {branch && (
                <div
                  className={`${Style.fw_350} ${Style.fs_14} d-flex gap-1 align-items-end`}
                >
                  <div>
                    <img src={clockIcon} alt="clock" />
                  </div>
                  <div className="d-flex align-items-end">
                    <div>{convertToAmPm(branch.start_time)}</div>
                    <div>-</div>
                    <div>{convertToAmPm(branch.end_time)}</div>
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex flex-column gap-2">
              <div className="d-flex flex-column gap-2">
                <div className={`${Style.fw_600} ${Style.fs_14}`}>
                  Nearby Branch:
                </div>
                <div className="d-flex gap-2 align-items-start">
                  <img src={locationIcon} alt="location" />
                  <div className={`${Style.fs_14} ${Style.fw_350}`}>
                    {branch?.address}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
